import {
    Card,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core";
import {AppBar, AppBarProps, Button, FormWithRedirect, TextInput, useNotify, UserMenu} from "react-admin";
import {getUser} from "../authProvider";
import {ChangePasswordMenu} from "../Users/ChangePasswordMenu";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {useToggler} from "../shared/hooks/useToggler";
import {useEffect, useRef, useState} from "react";
import {client, refreshPresenceInfoView} from "../dataProvider";
import IconCancel from "@material-ui/icons/Cancel";
import {QrReader} from "react-qr-reader";
import {useGeolocated} from 'react-geolocated';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {AccountCircle} from "@material-ui/icons";
import NotificationMenu from "./NotificationMenu";
import {NotificationIcons} from "./NotificationIcons";


/*
const GeolocationComponent: React.FC = () => {
  

  if (!isGeolocationAvailable) {
    return <div>Geolocalizzazione non disponibile nel tuo browser.</div>;
  }

  if (!isGeolocationEnabled) {
    return <div>Geolocalizzazione disabilitata. Per favore abilita la geolocalizzazione nelle impostazioni del dispositivo.</div>;
  }

  if (!coords) {
    return <div>In attesa di ottenere la posizione...</div>;
  }

  return (
    <div>
      <h1>Posizione GPS</h1>
      <p>Latitudine: {coords.latitude}</p>
      <p>Longitudine: {coords.longitude}</p>
    </div>
  );
};
*/

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    marginLeft: "0.5em",
  },

  menuButton: { display: "none" },
});

const videoConstraints = {
  width: 800,
  height: 1200,
  facingMode: "environment",
};

interface LocationOptions {
  enableHighAccuracy?: boolean;
  timeout?: number;
  maximumAge?: number;
}

interface LocationState {
  coords: {
    latitude: number | null;
    longitude: number | null;
    accuracy: number | null;
    altitude: number | null;
    altitudeAccuracy: number | null;
    heading: number | null;
    speed: number | null;
  };
  locatedAt: number | null;
  error: string | null;
}

const useLocation = (options: LocationOptions = {}) => {
  const [location, setLocation] = useState<LocationState>({
    coords: {
      latitude: null,
      longitude: null,
      accuracy: null,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      speed: null,
    },
    locatedAt: null,
    error: null,
  });

  useEffect(() => {
    // Ensuring this runs only in a client-side environment
    if (typeof window === "undefined" || !("geolocation" in navigator)) {
      setLocation((prevState) => ({
        ...prevState,
        error:
          "Geolocation is not supported by your browser or not available in the current environment",
      }));
      return;
    }

    const handleSuccess = (position: GeolocationPosition) => {
      setLocation({
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed,
        },
        locatedAt: position.timestamp,
        error: null,
      });
    };

    const handleError = (error: GeolocationPositionError) => {
      setLocation((prevState) => ({
        ...prevState,
        error: error.message,
      }));
    };

    const geoOptions = {
      enableHighAccuracy: options.enableHighAccuracy || false,
      timeout: options.timeout || Infinity,
      maximumAge: options.maximumAge || 0,
    };

    const watcher = navigator.geolocation.watchPosition(
      handleSuccess,
      handleError,
      geoOptions,
    );

    return () => navigator.geolocation.clearWatch(watcher);
  }, [options.enableHighAccuracy, options.timeout, options.maximumAge]);

  return location;
};


export const PresenceButton = (params: any) => {
  const { user, bigButton } = params;
  const { value, setTrue, setFalse } = useToggler();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [mouseIsOver, setMouseIsOver] = useState(false);
  const scanActive = useRef(true);
  const [startRoute, setStartRoute] = useState(false);
  const [notesIn, setNotesIn] = useState("");
  const [notesOut, setNotesOut] = useState("");

  const location = useLocation();

  const { isGeolocationAvailable, isGeolocationEnabled, coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true, // Richiede alta precisione
      timeout: 5000,           // Timeout di 10 secondi
      maximumAge: 0,            // No cached position
    },
    userDecisionTimeout: 5000,    // Timeout per la risposta dell'utente
  });

  const openPresence = (qr_code: any) => {
    setLoading(true)
    client("./presences/create_presence", {
      method: "GET",
      params: {
        qr: qr_code,
        gps: coords && coords.latitude && coords.longitude ? `${coords.latitude};${coords.longitude}` : undefined,
        start_route: startRoute,
        notes_in: notesIn,
      },
    })
      .then((response) => {
        if (response.error) {
          notify(response.error, { type: "error" });
          return
        }
        else {
          scanActive.current = false
          setFalse()
          setNotesIn("")
          notify("Presenza registrata", { type: "info" });
          refreshPresenceInfoView()
        }

      })
      .catch((e: any) => {
        notify("Errore", { type: "error" });
      })
      .finally(() => {
        setLoading(false)
        scanActive.current = false
      });

  };

  const closePresence = (qr_code: any) => {
    setLoading(true);
    if (!coords || !coords.latitude || !coords.longitude) {
      notify("Attenzione posizione GPS non rilevata", { type: "error" });
    }
    client("./presences/close_presence", {
      method: "GET",
      params: {
        qr: qr_code,
        gps: coords && coords.latitude && coords.longitude ? `${coords.latitude};${coords.longitude}` : undefined,
        notes_out: notesOut,
      },
    }).then((response) => {
      if (response.error) {
        notify(response.error, { type: "error" });
        return
      }
      else {
        scanActive.current = false
        setFalse()
        setNotesOut("")
        notify("Chiusura registrata", { type: "info" });
        refreshPresenceInfoView()
      }
    })
      .catch((error) => {
        notify("Errore", { type: "error" });
      })
      .finally(() => {
        setLoading(false);
        scanActive.current = false
      });
  };

  // The QR reader retains its initial callback: forward scans to the current form values.
  const onScan = useRef<(result: any, error: any) => void>(() => {});
  onScan.current = (result) => {
    if (!result || !scanActive.current) return;
    scanActive.current = false;
    if (!coords || !coords.latitude || !coords.longitude) {
      notify("Attenzione attendere posizione GPS", { type: "error" });
    }
    if (user.current_presence) {
      closePresence(result.text);
    } else {
      openPresence(result.text);
    }
  };

  return (
    <div style={{
      cursor: 'pointer',
      borderRadius: "5px",
      marginLeft: "10px",
      marginRight: "10px",
    }}
      onMouseEnter={() => (
        setMouseIsOver(true)
      )}
      onMouseLeave={() => (
        setMouseIsOver(false)
      )}
    >
      {
        bigButton ? <Card onClick={(e) => {
          e.stopPropagation();
          setTrue();
          scanActive.current = true;
          setMouseIsOver(false);
        }}
          style={{
            borderRadius: "1rem",
            padding: "0.5em",
            backgroundColor: mouseIsOver ? "lightgray" : "white",
          }}>
          <Grid container direction="row" justify="center" alignItems="center">
            {user.current_presence ? <ExitToAppIcon style={{ fontSize: '2em', color: "red", transform: 'scaleX(-1)', }} /> : <ExitToAppIcon style={{ fontSize: '2em', color: "green" }} />}
            <Typography variant="h4" align="center">
              {user.current_presence ? "Registra uscita" : "Registra entrata"}
            </Typography>
          </Grid>
        </Card> : <FiberManualRecordIcon
          style={{
            color: user.current_presence ? "green" : "red",
            height: "1.3em",
            width: "1.3em",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setTrue();
            scanActive.current = true;
            setMouseIsOver(false);
          }} />}

      {loading ? <CircularProgress size={18} thickness={2} /> : null}
      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="xs"
      >
        <FormWithRedirect
          resource="project-collaborators"
          save={() => { }}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <Typography
                  variant="h3"
                  align="center">
                  ESEGUI {user.current_presence ? "USCITA" : "ENTRATA"}
                </Typography>
                <Typography
                  variant="h6"
                  align="center"
                  style={{ color: coords && coords.latitude && coords.longitude ? "green" : "red" }} >
                  {coords && coords.latitude && coords.longitude ? "GPS OK" : "ATTESA GPS"}
                  {coords && coords.latitude && coords.longitude ? <a
                    href={`https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" (Vedi posizione)"}
                  </a>
                    : null}
                </Typography>
                <QrReader
                  onResult={(result: any, error: any) => onScan.current(result, error)}
                  constraints={{ facingMode: 'environment' }}

                />
                {
                  user.current_presence ?
                    (<>
                      <TextInput style={{ width: "100%" }} source="notes_out" label="Note"
                        onChange={(e) => setNotesOut(e.target.value)}
                      />
                      <Button
                        onClick={() => {
                          closePresence("")
                        }}
                        style={{ width: "100%" }}
                      >
                        <Typography>FORZA USCITA</Typography>
                      </Button>
                    </>) : (
                      <>
                        <FormControlLabel
                          control={
                            <Checkbox checked={startRoute} onChange={(e) => setStartRoute(e.target.checked)} />
                          }
                          label="Avvia giro"
                        />
                        <TextInput style={{ width: "100%" }} source="notes_in" label="Note"
                          onChange={(e) => setNotesIn(e.target.value)}
                        />
                        <Button
                          onClick={() => {
                            openPresence("")
                          }}
                          style={{ width: "100%" }}
                        >
                          <Typography>FORZA ENTRATA</Typography>
                        </Button>
                      </>)
                }

              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                {/*
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
                */}
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </div>
  );
}

const Timer = () => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      let tr = (Number(localStorage.getItem("last_request")) + 600000 - Date.now()) / 1000
      setTimeRemaining(tr > 0 ? tr : 0 || 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <Typography variant="h6" style={{ marginRight: "1em", border: "900", color: Math.floor(timeRemaining / 60) < 1 ? "red" : "inherit" }}>
      {Math.floor(timeRemaining / 60).toString().padStart(2, '0')}:{Math.floor(timeRemaining % 60).toString().padStart(2, '0')}
    </Typography>
  )
}

export const CustomAppBar = (props: AppBarProps) => {
  const [user, setUser] = useState(getUser());
  const classes = useStyles();
  useEffect(() => {
    setUser(getUser());
  }, [localStorage.getItem("user")]);

  return (
    <AppBar {...props}
      userMenu={
        user ?
          <>
            {
              window.location.hostname === "localhost" &&
              <Typography variant="h5" style={{ marginRight: "1em", border: "900", color: "red" }}>
                DEVELOPMENT
              </Typography>
            }
            <Timer />
            <NotificationIcons />
            {user.permissions.includes("base.view_recipientnotification") && <NotificationMenu/>}
            {
              user.is_internal_user && user.has_badge ?
                <PresenceButton user={user} />
                : null
            }
            <b>
              {user.username}
            </b>
            <UserMenu
              logout={props.logout}
              label={user.username}

              icon={user.photo ? (<img
                src={user.photo} alt="Avatar" style={{ width: "1.5em", height: "1.5em", borderRadius: "50%" }} />) : <AccountCircle />
              }
            >
              <ChangePasswordMenu />
            </UserMenu>
          </> : false
      }
      position="sticky" classes={classes} >
      <Typography
        variant="h6"
        color="inherit"
        className={classes.title}
        id="react-admin-title"
      />
    </AppBar >
  );
};
